import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import TravelPlanCard from '../TravelPlanCard';
import { NAVIGATION_PATHS, ENABLE_HOTELS_CTA } from '../../utils/constants';

const TravelPlansRoyal = ({ supportPhoneNumber, isAuthenticated, ldFlags }) => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);

  const goToHotels = () => {
    const destinationUrl = isAuthenticated
      ? NAVIGATION_PATHS.rclHotelsAuthenticated
      : NAVIGATION_PATHS.rclHotels;
    window.location.href = destinationUrl;
  };
  const enableHotels = ldFlags?.[ENABLE_HOTELS_CTA];

  return (
    <section className={classes.travelPlans}>
      <TravelPlanCard
        icon="transfers"
        cardTitle={getDictionary(Dictionary.airTravelPlansTransfersTitle.key)}
        cardInfo={getDictionary(Dictionary.airTravelPlansTransfersInfo.key)}
        supportPhoneNumber={supportPhoneNumber}
      />
      {enableHotels && (
        <TravelPlanCard
          icon="rcl-hotels"
          cardTitle={getDictionary(Dictionary.airTravelPlansHotelsTitle.key)}
          cardInfo={getDictionary(Dictionary.airTravelPlansHotelsInfo.key)}
          ctaLabel={getDictionary(Dictionary.airTravelPlansHotelsCTA.key)}
          ctaOnClick={goToHotels}
        />
      )}
    </section>
  );
};
TravelPlansRoyal.propTypes = {
  supportPhoneNumber: PropTypes.string,
  isAuthenticated: PropTypes.bool,
};
export default TravelPlansRoyal;
